import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { MachineryDataRequestPayloadTypes } from '../models/machine-management';

const machineryManagementService = {
  fetchMachineData: async (payload: MachineryDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.THINGS_MACHINES_BASE_URL, { params: payload });
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  getMachine: async (token: string, payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.THINGS_MACHINES_BASE_URL}/${payload.machine_id}`);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        data: res.data.length > 0 ? res?.data : [],
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addMachine: async (payload: any) => {
    try {
      delete payload.machine_id;
      const apiResponse = await axiosClient.post(apiPath.THINGS_MACHINES_BASE_URL, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateMachine: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(`${apiPath.THINGS_MACHINES_BASE_URL}/${payload.machine_id}`, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse?.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  deleteMachine: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.delete(`${apiPath.THINGS_MACHINES_BASE_URL}/${payload.machine_id}`);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse?.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  bulkUpload: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.THINGS_MACHINES_BASE_URL + 'bulk', payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

};

export default machineryManagementService;
